import { useCallback } from "react";
import { usePrismicLabels } from "./usePrismicLabel";

export const SINGLE_CART_LIMIT = 1000;

export const useUnitOfMeasure = () => {
  const { $pt } = usePrismicLabels();

  const getUnitOfMeasure = useCallback(
    (uomProperty: string, isPlural?: boolean) => {
      const uomMap: Record<string, { singular: string; plural: string }> = {
        "Box": { singular: "uom_box", plural: "uom_boxes" },
        "Pallet": { singular: "uom_pallet", plural: "uom_pallets" },
        "Overbox": { singular: "uom_overbox", plural: "uom_overboxes" },
        "Outer box": { singular: "uom_outerbox", plural: "uom_outerboxes" },
        "Can": { singular: "uom_can", plural: "uom_cans" },
        "Bundle": { singular: "uom_bundle", plural: "uom_bundles" },
        "Bus": { singular: "uom_bus", plural: "uom_buses" },
        "Pouch": { singular: "uom_pouch", plural: "uom_pouches" },
        "Cassette": { singular: "uom_cassette", plural: "uom_cassettes" },
        "Tube": { singular: "uom_tube", plural: "uom_tubes" },
        "Meter": { singular: "uom_meter", plural: "uom_meters" },
        "Couple": { singular: "uom_couple", plural: "uom_couples" },
        "Band": { singular: "uom_band", plural: "uom_bands" },
        "Cannister": { singular: "uom_cannister", plural: "uom_cannisters" },
        "Strip": { singular: "uom_strip", plural: "uom_strips" },
        "Piece": { singular: "uom_piece", plural: "uom_pieces" },
        "Roll": { singular: "uom_rol", plural: "uom_rols" },
        "Set": { singular: "uom_set", plural: "uom_sets" },
        "Gram": { singular: "uom_gram", plural: "uom_grams" },
        "Kilogram": { singular: "uom_kilo", plural: "uom_kilos" },
      };

      const uom = uomMap[uomProperty];
      if (uom) {
        return isPlural ? $pt(uom.plural) : $pt(uom.singular);
      }
      return isPlural ? $pt("uom_pieces") : $pt("uom_piece");
    },
    [$pt]
  );

  return getUnitOfMeasure;
}